import { render, staticRenderFns } from "./s-form-select.vue?vue&type=template&id=31124a52"
import script from "./s-form-select.vue?vue&type=script&lang=js"
export * from "./s-form-select.vue?vue&type=script&lang=js"
import style0 from "./s-form-select.vue?vue&type=style&index=0&id=31124a52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports